<ng-container>
  <div class="date-from uppertext-no-viewport" *ngIf="dateResult.isSameDay === true || dateFrom == undefined; else rangeDate">
    {{dateFrom | date :'d MMMM yyyy'}}
  </div>
  <ng-template #rangeDate>
    <div *ngIf="dateResult.isSameMonth && dateResult.isSameYear" class="date-to uppertext-no-viewport">{{dateFrom | date : 'd' }} - {{dateTo | date : 'd MMMM yyyy' }} </div>
    <div *ngIf="dateResult.isSameMonth === false && dateResult.isSameYear" class="date-to uppertext-no-viewport">{{dateFrom | date : 'd MMM' }} - {{dateTo | date : 'd MMM yyyy' }} </div>
    <div *ngIf="dateResult.isSameMonth === false && dateResult.isSameYear === false" class="date-to uppertext-no-viewport">{{dateFrom | date : 'd MMM yyyy' }} - {{dateTo | date : 'd MMM yyyy' }} </div>

  </ng-template>
</ng-container>
